/**
 * ScrapAudienceDialog - Dialog para importar dados do ScrapAudience
 *
 * Permite selecionar arquivo JSON gerado pelo ScrapAudience para importação.
 */
import React from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Typography,
  Box,
  DialogContent,
  DialogActions
} from '@mui/material';
import { Publish as PublishIcon } from '@mui/icons-material';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';

const ScrapAudienceDialog = ({
  open,
  onClose,
  availableFiles,
  selectedFile,
  onFileChange,
  onImport
}) => {
  return (
    <PlatformDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <PlatformDialogTitle
         title="Importar Audiência"
         subtitle="ScrapAudience JSON Sync"
         icon={<PublishIcon />}
         onClose={onClose}
         color="success"
      />
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Selecione o arquivo de dados processados para atualizar a base:
        </Typography>
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Arquivo Disponível</InputLabel>
          <Select 
            value={selectedFile} 
            onChange={(e) => onFileChange(e.target.value)} 
            label="Arquivo Disponível"
            sx={{ borderRadius: 2 }}
          >
            {availableFiles.map((file) => (
              <MenuItem key={file.filename} value={file.filename}>
                {file.filename} ({file.recordCount} registros)
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Alert severity="success" variant="outlined" sx={{ borderRadius: 2 }}>
          Os dados de audiência serão sincronizados automaticamente com o banco de dados.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
        <Button onClick={onClose} sx={{ fontWeight: 600 }}>Cancelar</Button>
        <Button 
          onClick={onImport} 
          variant="contained" 
          color="success"
          sx={{ fontWeight: 700, borderRadius: 2, px: 3 }}
          startIcon={<PublishIcon />}
        >
          Sincronizar Agora
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

export default ScrapAudienceDialog;
